import { NotificationImportant } from "@mui/icons-material";
import { isEmpty } from "lodash";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import DismissibleAlert from "./DismissibleAlert";

const UnderwritingRequirementsAlert = () => {
  const financingRequests = useSelector((state) => state?.financingRequests);

  const hasUnderwritingRequirements = useMemo(() => {
    if (isEmpty(financingRequests)) {
      return false;
    }
    return financingRequests.some(
      (item) =>
        Array.isArray(item.underwritingRequirements) &&
        item.underwritingRequirements.length > 0,
    );
  }, [financingRequests]);

  return (
    <DismissibleAlert
      show={hasUnderwritingRequirements}
      severity="error"
      icon={<NotificationImportant className="thin" fontSize="inherit" />}
      // fontSize="14px"
      // alertId="underwriting-requirements"
      //   hideDuration={24} // Hide for 24 hours after dismiss
    >
      Action Required: Your loan has outstanding underwriting conditions that
      need attention. Review your financing request to address these items and
      move forward.
    </DismissibleAlert>
  );
};

export default UnderwritingRequirementsAlert;
